const normalizeKey = (s) => {
    if (!s) return '';
    return String(s)
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_+|_+$/g, '');
};

export const MANDATORY_CRITERIA_SUBTITLES = {
    factuality: 'No hallucinations - only facts from the source',
    completeness: 'Covers the main idea and key details',
    conciseness: 'No redundancy or fluff',
    coherence: 'Logical flow and readability',
    compression: 'Meaning preserved while reducing length',
};

export function buildBuiltinCriteriaItems(mandatoryCriteriaPrompts, enabledById = {}) {
    const prompts = mandatoryCriteriaPrompts && typeof mandatoryCriteriaPrompts === 'object'
        ? mandatoryCriteriaPrompts
        : {};

    return Object.keys(prompts).map((key) => ({
        id: key,
        type: 'builtin',
        title: key.charAt(0).toUpperCase() + key.slice(1),
        subtitle: MANDATORY_CRITERIA_SUBTITLES[key] || '',
        enabled: enabledById[key] ?? true,
        promptTemplate: prompts[key],
    }));
}

export function isJudgeMetricEnabled(metricKey, enabledById) {
    const enabled = enabledById && typeof enabledById === 'object' ? enabledById : {};
    if (enabled[metricKey] === false) return false;
    if (enabled[`custom_${metricKey}`] === false) return false;
    return true;
}

export function usecaseToJudgeConfig(usecase) {
    const userPrompts = usecase?.user_criteria_prompts && typeof usecase.user_criteria_prompts === 'object'
        ? usecase.user_criteria_prompts
        : {};
    const enabledById = usecase?.llm_judge_enabled_by_id && typeof usecase.llm_judge_enabled_by_id === 'object'
        ? usecase.llm_judge_enabled_by_id
        : {};

    const judgeModelName = usecase?.judge_model_identifier?.model_name || null;

    const custom = Object.entries(userPrompts).map(([name, promptTemplate]) => {
        const id = `custom_${normalizeKey(name)}`;
        return {
            id,
            type: 'custom',
            title: name,
            subtitle: 'Write your own prompt - own evaluation criteria',
            promptTemplate,
            enabled: enabledById[id] ?? true,
            judgeModel: judgeModelName,
        };
    });

    return {
        judgeModel: judgeModelName,
        custom,
        enabledById,
    };
}

export function judgeConfigToUsecaseUpdatePayload(config) {
    const custom = Array.isArray(config?.custom) ? config.custom : [];
    const user_criteria_prompts = custom.reduce((acc, c) => {
        const name = (c?.title || '').trim();
        const prompt = c?.promptTemplate;
        if (!name) return acc;
        acc[name] = prompt || '';
        return acc;
    }, {});

    return {
        user_criteria_prompts,
        llm_judge_enabled_by_id: config?.enabledById || {},
    };
}

